<div class="modal-header b pb-0 px-5 pt-5">
  <h5 class="modal-title f-14 font-weight-600 text-defualt" id="createTalentTitle">Change Password</h5>
  <span type="button" class="close font-weight-normal f-16 ms-auto" data-bs-dismiss="modal" aria-bs-label="Close" (click)="modalService.dismissAll()">
   <i class="fas fa-times f-14 text-black"></i>
  </span>
</div>

<div class="modal-body mb-4 px-5 pb-0">
  <form [formGroup]="changepassword_form">
    <div class="row">
      <div class="col-md-11">
        <div class="position-relative mb-4">
          <label class="font-weight-500">Old Password<span class="text-danger">*</span></label>
            <input data-testid="auto-app-change-password-input-1" [type]="show ? 'text' : 'password'" class="wc-form-control" name="password"
            formControlName="old_pwd" id="old_pwd" placeholder="Enter password" (input)="incorrectoldpw = false">
            <span class="showpassword"><i class="fas text-webbtree-green" [ngClass]="show ? 'fa-eye-slash' : 'fa-eye'"
              (click)="show=!show"></i></span>

        </div>
      </div>
      <div class="col-12 d-flex">
      <div class="col-md-11 pl-0 pr-0">
        <div class="position-relative mb-4 pl-0">
          <label class="font-weight-500">New Password<span class="text-danger">*</span></label>
            <input data-testid="auto-app-change-password-input-2" [type]="show1 ? 'text' : 'password'" class="wc-form-control" name="password"
            formControlName="new_pwd" id="new_pwd" placeholder="Enter password" (click)="showpassworderror()" (input)="checkpassword()">
            <span class="showpassword"><i class="fas text-webbtree-green" [ngClass]="show1 ? 'fa-eye-slash' : 'fa-eye'"
              (click)="show1=!show1"></i></span>
          <p *ngIf="changepassword_form.get('new_pwd').errors?.required && (changepassword_form['controls'].new_pwd.dirty || changepassword_form['controls'].new_pwd.touched)"
            [ngClass]="['f-12','mt-1','text-danger']">New Password is required</p>
            <p *ngIf="changepassword_form.get('old_pwd').errors?.required && (changepassword_form['controls'].old_pwd.dirty || changepassword_form['controls'].old_pwd.touched)"
            [ngClass]="['f-12','mt-1','text-danger']">Old Password is required</p>
            <p *ngIf="changepassword_form['controls'].new_pwd.hasError('pwdmatch')"
            [ngClass]="['f-12','mt-1','text-danger']">New Password must not be same as Old Password </p>


            <p class="text-danger"
            *ngIf="!changepassword_form.controls['new_pwd'].hasError('required') && changepassword_form.controls['new_pwd'].touched">
            <ng-container *ngIf="(changepassword_form.controls['new_pwd'].hasError('required')
          || changepassword_form.controls['new_pwd'].hasError('minlength')
          || changepassword_form.controls['new_pwd'].hasError('maxlength')
          || changepassword_form.controls['new_pwd'].hasError('hasNumber')
          || changepassword_form.controls['new_pwd'].hasError('hasCapitalCase')
          || changepassword_form.controls['new_pwd'].hasError('hasSmallCase')
          || changepassword_form.controls['new_pwd'].hasError('hasSpecialCharacters')
          || changepassword_form.controls['new_pwd'].hasError('hasKeyword')); else PasswordError">
              Invalid password pattern
            </ng-container>
            <ng-template #PasswordError></ng-template>
          </p>
          <div class="passwordValidMsg" *ngIf="showpassword">
            <label class="col f-12 d-flex"
              [ngClass]="changepassword_form.controls['new_pwd'].hasError('required') || changepassword_form.controls['new_pwd'].hasError('hasKeyword')  ? 'text-danger' : 'text-success'">
              <i class="material-icons f-12 mr-1">{{ changepassword_form.controls['new_pwd'].hasError('required') ||
                changepassword_form.controls['new_pwd'].hasError('hasKeyword') ? 'cancel' :
                'check_circle' }}</i>
              Cannot contain reserved keywords for e.g. 'password'
            </label>
            <label class="col f-12 d-flex"
              [ngClass]="changepassword_form.controls['new_pwd'].hasError('required') || changepassword_form.controls['new_pwd'].hasError('minlength') || changepassword_form.controls['new_pwd'].hasError('maxlength')  ? 'text-danger' : 'text-success'">
              <i class="material-icons f-12 mr-1">{{ changepassword_form.controls['new_pwd'].hasError('required') ||
                changepassword_form.controls['new_pwd'].hasError('minlength') ||
                changepassword_form.controls['new_pwd'].hasError('maxlength') ? 'cancel' :
                'check_circle' }}</i>
              Must be 8-48 characters!
            </label>
            <label class="col f-12 d-flex"
              [ngClass]="changepassword_form.controls['new_pwd'].hasError('required') || changepassword_form.controls['new_pwd'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
              <i class="material-icons f-12 mr-1">{{ changepassword_form.controls['new_pwd'].hasError('required') ||
                changepassword_form.controls['new_pwd'].hasError('hasNumber') ? 'cancel' :
                'check_circle' }}</i>
              Must contain at least 1 number!
            </label>
            <label class="col f-12 d-flex"
              [ngClass]="changepassword_form.controls['new_pwd'].hasError('required') || changepassword_form.controls['new_pwd'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
              <i class="material-icons f-12 mr-1">{{ changepassword_form.controls['new_pwd'].hasError('required') ||
                changepassword_form.controls['new_pwd'].hasError('hasCapitalCase') ? 'cancel' :
                'check_circle' }}</i>
              Must contain at least 1 in Capital Case!
            </label>
            <label class="col f-12 d-flex"
              [ngClass]="changepassword_form.controls['new_pwd'].hasError('required') || changepassword_form.controls['new_pwd'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
              <i class="material-icons f-12 mr-1">{{ changepassword_form.controls['new_pwd'].hasError('required') ||
                changepassword_form.controls['new_pwd'].hasError('hasSmallCase') ? 'cancel' :
                'check_circle' }}</i>
              Must contain at least 1 Letter in Small Case!
            </label>
            <label class="col f-12 d-flex"
              [ngClass]="changepassword_form.controls['new_pwd'].hasError('required') || changepassword_form.controls['new_pwd'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
              <i class="material-icons f-12 mr-1">{{ changepassword_form.controls['new_pwd'].hasError('required') ||
                changepassword_form.controls['new_pwd'].hasError('hasSpecialCharacters') ? 'cancel' :
                'check_circle' }}</i>
              Must contain at least 1 Special Character!
            </label>
          </div>

            <!-- <p  *ngIf="changepassword_form.controls['new_pwd'].hasError('minlength')
            || changepassword_form.controls['new_pwd'].hasError('hasNumber')
            || changepassword_form.controls['new_pwd'].hasError('hasCapitalCase')
            || changepassword_form.controls['new_pwd'].hasError('hasSmallCase')
            || changepassword_form.controls['new_pwd'].hasError('hasSpecialCharacters')"  [ngClass]="['f-12','mt-1','text-danger']">
               Invalid Password Pattern
            </p> -->
        </div>
      </div>

      <!-- <div class="col-1 mt-35">
        <span *ngIf="changepassword_form.controls['new_pwd'].hasError('minlength')
        || changepassword_form.controls['new_pwd'].hasError('hasNumber')
        || changepassword_form.controls['new_pwd'].hasError('hasCapitalCase')
        || changepassword_form.controls['new_pwd'].hasError('hasSmallCase')
        || changepassword_form.controls['new_pwd'].hasError('hasSpecialCharacters')" [ngClass]="['f-12','mt-1','text-danger']"
        [ngbTooltip]="password_error" [placement]="right">
        <i class="fas fa-info-circle f-12"></i>

        <ng-template #password_error>
          <ul class="error-text">
              <li *ngIf="changepassword_form.controls['new_pwd'].hasError('hasCapitalCase')">One uppercase alphabet is required</li>
              <li *ngIf="changepassword_form.controls['new_pwd'].hasError('hasSmallCase')"> One lowercase alphabet is required</li>
              <li *ngIf="changepassword_form.controls['new_pwd'].hasError('hasNumber')">One number is required</li>
              <li *ngIf="changepassword_form.controls['new_pwd'].hasError('hasSpecialCharacters')"> One special character is required</li>
              <li *ngIf="changepassword_form.controls['new_pwd'].hasError('minlength')"> Minimum length 8 is required</li>
          </ul>
        </ng-template>
        </span>


      </div> -->
    </div>

      <div class="col-md-11">
        <div class="position-relative mb-4">
          <label class="font-weight-500">Re-Type Password<span class="text-danger">*</span></label>
            <input data-testid="auto-app-change-password-input-3" [type]="show2 ? 'text' : 'password'" class="wc-form-control" name="password"
            formControlName="confirm_pwd" id="confirm_pwd" placeholder="Enter password" (input)="reconfirmpwd()">
            <span class="showpassword"><i class="fas text-webbtree-green" [ngClass]="show2 ? 'fa-eye-slash' : 'fa-eye'"
              (click)="show2=!show2"></i></span>
          <p *ngIf="changepassword_form.get('confirm_pwd').errors?.required && (changepassword_form['controls'].confirm_pwd.dirty || changepassword_form['controls'].confirm_pwd.touched)"
            [ngClass]="['f-12','mt-1','text-danger']">Confirm Password is required</p>
          <p *ngIf="changepassword_form['controls'].confirm_pwd.hasError('invalidpwd')"
            [ngClass]="['f-12','mt-1','text-danger']">Password must be same </p>

          <p *ngIf="incorrectoldpw" [ngClass]="['f-12','mt-1','text-danger']">Old password is not correct </p>
        </div>
      </div>
    </div>
  </form>
</div>


<ng-template #successModal class="modal">
  <div class="modal-content">
      <div class="modal-body px-6 pb-6 pt-3">
          <div class="row mb-3">
              <div class="col pb-5">
                  <button data-testid="auto-app-change-password-button-1" type="button" class="close position-absolute tr0" data-dismiss="modal"
                      aria-label="Close" (click)="modaldismiss()">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
          </div>
          <div class="row mb-4">
              <div class="col text-center">
                  <img src="./../../../assets/images/success-vector.png" alt="img-fluid">
              </div>
          </div>
          <div class="row mb-4">
              <div class="col">
                  <p class="text-center">Password change successfully</p>
              </div>
          </div>
          <div class="row">
              <div class="col-md-10 mx-auto d-flex">
                  <button data-testid="auto-app-change-password-button-2" class="btn-trms-small m-auto" (click)="modaldismiss()">DONE</button>
              </div>
          </div>
      </div>
  </div>
</ng-template>

<div class="modal-footer b pb-5">
  <button data-testid="auto-app-change-password-button-3" type="button" class="btn-trms-small m-auto" data-dismiss="modal"
    (click)="changePassword()">Save</button>
</div>
